/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";

import { Formik, Field } from "formik";
import * as Yup from "yup";
import Alert from "../../shared/components/Alert";

import FormField from "../../shared/components/form/FormField";
import { resetpassword } from "../../actions/auth/authAction";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { UncontrolledTooltip, Nav, NavItem, NavLink, Button } from "reactstrap";

import hero1 from "../../assets/images/hero-bg/hero-1.jpg";

import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

const initialValues = { password: "", cpassword: "" };
const validationSchema = Yup.object({
  password: Yup.string("")
    .min(8, "Password must contain at least 8 characters")
    .required("Enter your password"),
  cpassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords do not match")
    .required("Confirm your required"),
});

class ResetPassword extends PureComponent {
  state = {
    loading: false,
    success: null,
    error: null,
    showPassword: false,
    showConfirm: false,
  };
  // resetForm;

  showPassword = (e) => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  showConfirm = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: !this.state.showConfirm,
    });
  };

  openSocialLink = (socialType) => {
    switch (socialType) {
      case "twitter":
        window.open("https://twitter.com/BetterCapitalUS", "_blank");
        break;
      case "facebook":
      default:
        window.open("https://fb.com/bettercapital.us", "_blank");
        break;
    }
  };

  handleSubmit = (values) => {
    const queryParams = queryString.parse(this.props.location.search);
    this.setState({ loading: true, error: null, success: null });
    this.props.resetpassword({
      password: values.password,
      email: queryParams.email.replace(" ", "+"),
      activation: queryParams.activation,
      user_role: "partner",
    });
  };

  componentDidMount() {
    if (this.props.auth.isAuthenticated) this.props.history.push("/");
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetPasswordState.resetPasswordSuccess === true) {
      this.setState({
        loading: false,
        success: nextProps.resetPasswordState.message,
      });
      return setTimeout(() => this.props.history.push("/login"), 1000);
    } else if (nextProps.resetPasswordState.resetPasswordSuccess === false)
      this.setState({
        loading: false,
        error: nextProps.resetPasswordState.error,
      });
  }

  render() {
    let alertContent;
    if (this.state.error) {
      alertContent = (
        <Alert color="danger" className="alert--bordered" icon>
          <p>{this.state.error}</p>
        </Alert>
      );
    } else if (this.state.success) {
      alertContent = (
        <Alert color="success" className="alert--bordered" icon>
          <p>{this.state.success}</p>
        </Alert>
      );
    }

    return (
      <div
        className="hero-wrapper bg-composed-wrapper bg-arielle-smile overflow-hidden"
        style={{ margin: "0 auto", marginTop: "50px", width: "50%" }}
      >
        <div className="flex-grow-1 w-100 d-flex align-items-center">
          <div
            className="bg-composed-wrapper--image"
            style={{ backgroundImage: "url(" + hero1 + ")" }}
          />
          <div className="bg-composed-wrapper--bg bg-second opacity-5" />
          <div className="bg-composed-wrapper--content py-5">
            <div className="header-nav-wrapper px-4 w-100 bg-secondary shadow-sm-dark navbar-light">
              <div className="text-center w-100 d-block font-weight-bold text-black-50 text-uppercase">
                <img
                  src="/assets/images/logo.png"
                  width="300px"
                  alt="BetterCapital.US"
                />
              </div>
            </div>
            <div className="container text-center py-5">
              <div className="text-white mt-3 px-5">
                <h1 className="display-3 font-weight-bold">Reset password</h1>
                <p className="font-size-lg text-white-50 px-2 px-xl-5 my-4 d-block">
                  Set a new password for your account.
                </p>
                <div className="divider border-2 my-5 mx-auto border-light opacity-2 rounded w-50" />
                <div className="px-5">
                  {alertContent}
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.handleSubmit}
                    render={(props) => {
                      const { handleSubmit, errors /* resetForm */ } = props;
                      // this.resetForm = resetForm;
                      return (
                        <Fragment>
                          <form className="form" onSubmit={handleSubmit}>
                            <p style={{ color: "red" }}>
                              {errors && errors.password}
                            </p>

                            <div className="form-group">
                              <Field
                                name="password"
                                component={FormField}
                                className="input-lg"
                                type={"password"}
                                placeholder="Password"
                              />
                            </div>

                            <div className="form-group">
                              <Field
                                name="cpassword"
                                component={FormField}
                                type={"password"}
                                placeholder="Confirm password"
                              />
                            </div>

                            <div className="account__btns">
                              <Button
                                color="warning"
                                disabled={this.props.loading}
                                type="submit"
                              >
                                {this.props.loading
                                  ? "Please wait..."
                                  : "Reset"}
                              </Button>
                            </div>
                          </form>
                        </Fragment>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-footer pb-4">
          <Nav className="nav-transparent">
            <NavItem>
              <NavLink
                className="text-white-50"
                id="FacebookBtnTooltip15"
                href="#/"
                onClick={(e) => this.openSocialLink("facebook")}
              >
                <FontAwesomeIcon icon={faFacebook} className="font-size-lg" />
                <span className="d-lg-none">Facebook</span>
              </NavLink>
              <UncontrolledTooltip target="FacebookBtnTooltip15">
                Facebook
              </UncontrolledTooltip>
            </NavItem>
            <NavItem>
              <NavLink
                className="text-white-50"
                id="btnTwitterTooltip"
                href="#/"
                onClick={(e) => this.openSocialLink("twitter")}
              >
                <FontAwesomeIcon icon={faTwitter} className="font-size-lg" />
                <span className="d-lg-none">Twitter</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className="text-white-50"
                id="btnInstagramTooltip"
                href="#/"
                onClick={(e) => e.preventDefault()}
              >
                <FontAwesomeIcon icon={faInstagram} className="font-size-lg" />
                <span className="d-lg-none">Instagram</span>
              </NavLink>
            </NavItem>
          </Nav>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.login,
  resetPasswordState: state.resetPassword,
});
const mapDispatchToProps = (dispatch) => ({
  resetpassword: (userData) => resetpassword(userData, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResetPassword));
